import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { onAnimStackReady } from "../main/animStack";

onAnimStackReady(() => {
  if (
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  ) {
    return;
  }

  const EASE_OUT = "power2.out";
  const EASE_INOUT = "power2.inOut";
  const DURATION = 0.9;
  const START_POS = "top 85%";

  function reveal(target, vars) {
    return gsap.from(
      target,
      Object.assign(
        {
          duration: DURATION,
          ease: EASE_OUT,
          opacity: 0,
          scrollTrigger: {
            trigger: target,
            start: START_POS,
            toggleActions: "play none none none",
            once: true,
          },
        },
        vars || {},
      ),
    );
  }

  // ==========================================================================
  // HERO
  // ==========================================================================
  const heroSection = document.querySelector("#section-21-1198");
  if (heroSection) {
    gsap.to(".page--home--hero-slider--img", {
      yPercent: 12,
      ease: "none",
      scrollTrigger: {
        trigger: heroSection,
        start: "top top",
        end: "bottom top",
        scrub: true,
      },
    });

    const heroTl = gsap.timeline({
      delay: 0.15,
      defaults: { ease: EASE_OUT },
    });
    heroTl
      .from("#headline-31-1198", {
        duration: 1.0,
        opacity: 0,
        y: 30,
        clipPath: "inset(0 0 100% 0)",
      })
      .from(
        "#headline-32-1198",
        {
          duration: 1.0,
          opacity: 0,
          y: 30,
          clipPath: "inset(0 0 100% 0)",
        },
        "-=0.7",
      )
      .from(
        "#text_block-33-1198",
        { duration: 0.8, opacity: 0, y: 16 },
        "-=0.6",
      )
      .from(
        "#link-36-1198",
        {
          duration: 0.7,
          opacity: 0,
          scale: 0.6,
          ease: "back.out(1.8)",
        },
        "-=0.5",
      );
  }

  // ==========================================================================
  // VALUES INTRO
  // ==========================================================================
  reveal("#div_block-48-1198", { x: -120, duration: 1.0 });
  reveal("#div_block-49-1198", { y: 30, duration: 1.0 });

  // ==========================================================================
  // PHILOSOPHY CARDS
  // ==========================================================================
  document
    .querySelectorAll(".page-about--philosophy-card--item")
    .forEach(function (item, index) {
      const overlay = item.querySelector(
        ".page-about--philosophy-card--img-overlay",
      );
      const content = item.querySelector(
        ".page-about--philosophy-card--content-wrap",
      );
      if (!overlay || !content) return;

      gsap.from(overlay, {
        duration: 1.0,
        width: "100%",
        ease: EASE_INOUT,
        scrollTrigger: {
          trigger: item,
          start: START_POS,
          toggleActions: "play none none none",
          once: true,
        },
      });

      const isEven = index % 2 === 0;
      const fromX = isEven ? 80 : -80;
      gsap.from(content, {
        duration: 1.0,
        opacity: 0,
        x: fromX,
        ease: EASE_OUT,
        scrollTrigger: {
          trigger: item,
          start: START_POS,
          toggleActions: "play none none none",
          once: true,
        },
      });
    });

  // ==========================================================================
  // OUR VALUES CARDS
  // ==========================================================================
  document
    .querySelectorAll(".page-about--our-values-card--item")
    .forEach(function (item) {
      const content = item.querySelector(
        ".page-about--our-values-card--content-wrap",
      );
      const overlays = item.querySelectorAll(
        ".page-about--our-values-card--overlay",
      );

      if (content) {
        gsap.from(content, {
          duration: 1.0,
          opacity: 0,
          y: 60,
          ease: EASE_OUT,
          scrollTrigger: {
            trigger: item,
            start: START_POS,
            toggleActions: "play none none none",
            once: true,
          },
        });
      }

      if (overlays.length) {
        gsap.from(overlays, {
          duration: 1.1,
          height: "100%",
          stagger: 0.05,
          ease: EASE_INOUT,
          scrollTrigger: {
            trigger: item,
            start: START_POS,
            toggleActions: "play none none none",
            once: true,
          },
        });
      }
    });

  // ==========================================================================
  // PRINCIPAL
  // ==========================================================================
  //   reveal("#image-466-1198", { duration: 1.1 });

  const principalContent = document.querySelector("#div_block-467-1198");
  if (principalContent) {
    gsap.from(principalContent.children, {
      duration: 0.8,
      opacity: 0,
      y: 30,
      stagger: 0.12,
      ease: EASE_OUT,
      scrollTrigger: {
        trigger: principalContent,
        start: START_POS,
        toggleActions: "play none none none",
        once: true,
      },
    });
  }

  // ==========================================================================
  // TEAM
  // ==========================================================================
  reveal("#headline-125-1198", { y: 24 });

  ScrollTrigger.batch(".page-about--team-card--item", {
    start: START_POS,
    once: true,
    onEnter: function (batch) {
      gsap.from(batch, {
        duration: DURATION,
        opacity: 0,
        y: 60,
        stagger: 0.05,
        ease: EASE_OUT,
        clearProps: "transform",
      });
    },
  });
  // ==========================================================================
  // VIDEO AUTO-PLAY
  // ==========================================================================
  const valueVideo = document.querySelector("#code_block-50-1198");
  if (valueVideo && typeof valueVideo.play === "function") {
    ScrollTrigger.create({
      trigger: valueVideo,
      start: "top 80%",
      once: true,
      onEnter: function () {
        const playAttempt = valueVideo.play();
        if (playAttempt && typeof playAttempt.catch === "function") {
          playAttempt.catch(function () {});
        }
      },
    });
  }
});
